<div class="row full-height">
  <div class="col-md-12">
    <form #AddPostToProjectForm="ngForm" class="add-post-to-project-form d-flex" novalidate (ngSubmit)="addPostsToProject()">
      <div class="d-flex flex-column flex-auto">
        <div class="bottombar-buttons">
          <button class="button green save-project pull-right" type="submit">{{'common.btn.save' | translate}}</button>
          <button class="button red back-to-preview-button pull-right" (click)="backToPreviewInfluencer()">{{'common.btn.back' | translate}}</button>
        </div>
        <div class="bottombar-content flex-auto">
          <div class="d-flex flex-row flex-auto">
            <div class="left-side">
              <div *ngIf="isShowSummarize" class="summarize-message" [innerHTML]="'discover.project_to_add_post_message' | translate:{numOfPost: numberSelectedPost}">
              </div>
              <div class="material-field project-selection">
                <achoo-filter-box label="{{'discover.project_to_add_post' | translate}}"
                                  [options]="projectList"
                                  (selectEvent)="onSelectProject($event)"
                                  placeholder="{{'discover.project_to_add_post_placeholder' | translate}}"
                                  [(model)]="postAddToProject.projectId">
                </achoo-filter-box>
                <div class="create-new-project-btn">
                  <button class="button add-icon-btn"
                          actionByLevels="Edit Project"
                          [wallName]="'Projects Disabled'"
                          (afterChecking)="createNewProject()">{{'discover.new_project_button' | translate}}</button>
                </div>
              </div>
              <div class="material-field" *ngIf="selectedProject">
                <achoo-keywork-input-field #mentionInput label="{{'campaigns.mentions' | translate}}"
                                           name="project_keywords"
                                           [activePage]="activePage"
                                           [actionSource]="actionSource"
                                           [readOnly]="true"
                                           [mentions]="selectedProject.keywords">
                </achoo-keywork-input-field>
                <div class="keyword-seperate-line"></div>
              </div>
            </div>
            <div class="right-side"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/add-posts-to-project/add-posts-to-project.component.html